import React, { useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import styled from 'styled-components';
import Content from 'components/basics/Content';
import { Button } from 'components/basics';
import { FormattedMessage } from 'react-intl';
import Markdown from 'markdown-to-jsx';
import { FORM_TYPES } from 'components/pages/Index/FormModals/formConfigs';
import FormModal from 'components/pages/Index/FormModals/FormModal';
import { colors } from 'styles';
import BlockText from '../../Solution/Marketing/SliderBlock/Slides/BlockText';
import {
  ImageGrid,
  QuoteImage
} from '../../Solution/Marketing/SliderBlock/Slides/Slide';

const StyledGrid = styled(Grid)`
  ${Content};
  flex-direction: ${({ centered }) => centered && 'column'};
  max-width: 1200px;
  padding-bottom: 2rem;
  z-index: 2;
`;
const GridText = styled(Grid)`
  padding: 1rem;
`;
const GridTextItems = styled(Grid)`
  flex: 0 0 auto;
`;
const Title = styled(Typography)`
  padding-bottom: 1rem;
  font-size: ${props => props.theme.typography.h5.fontSize}px;
`;
const TestimonialTitle = styled(Title)`
  margin-top: 4rem;
  padding-bottom: 0;
`;
const StyledButton = styled(Button)`
  margin-top: 4rem;
`;
const StyledMarkdown = styled(Markdown)`
  margin: 0;
  font-family: ${props => `${props.theme.typography.fontFamily};
  font-weight: normal;
`};
  font-size: ${props => `${props.theme.typography.body2.fontSize}px`};
  > p {
    margin: 0;
  }
  > ul {
    margin: 0;
    margin-top: 1rem;
  }
`;

const KeypointsBlocks = ({ data, lang, clientCase, testimonialData }) => {
  const [open, setOpen] = useState(false);
  const translatedUseCase = <FormattedMessage id={`useCases.${clientCase}`} />;
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getTestimonialData = clientCase => {
    const step = testimonialData.markdownContent.find(
      data => data.frontmatter.useCases === clientCase
    );
    const imageNameInMarkdownContent = testimonialData.markdownContent.find(
      data => data.frontmatter.useCases === clientCase
    )?.frontmatter.imageName;
    const imgSource = testimonialData.images.find(
      image => image.name === imageNameInMarkdownContent
    )?.childImageSharp?.fluid?.src;
    if (step) {
      return (
        <StyledGrid
          container
          direction="row"
          wrap={'wrap'}
          justify="center"
          key={`Slides${clientCase}`}
          alignItems="center"
          centered={1}
        >
          <TestimonialTitle variant={'h2'}>
            <FormattedMessage id={`useCases.testimony`} />
          </TestimonialTitle>
          <ImageGrid container alignItems="center" justify="center">
            <QuoteImage src={imgSource} />
          </ImageGrid>
          <BlockText step={step} textAlign={'center'} fromUseCase />
        </StyledGrid>
      );
    }
  };
  return (
    <Grid container justify={'center'}>
      <StyledGrid container justify={'center'} alignItems={'flex-start'}>
        {data.markdownContent.map((keypoint, index) => (
          <GridText
            container
            justify={'center'}
            alignItems={'center'}
            item
            xs={12}
            sm={6}
            md={6}
            lg={6}
            direction="column"
            key={`KeypointsBlock${index}`}
          >
            <GridTextItems container item xs={10} sm={12} md={8} lg={8}>
              <Title variant={'h2'}>{keypoint.frontmatter.title} </Title>
              <StyledMarkdown>
                {`### ${keypoint.rawMarkdownBody}`}
              </StyledMarkdown>
            </GridTextItems>
          </GridText>
        ))}
        {getTestimonialData(clientCase)}
        <StyledButton
          size="large"
          variant="contained"
          color="primary"
          mt={2}
          onClick={() => handleOpen()}
          customBackgroundColor={colors.red}
          customHoverBackgroundColor={colors.shades.red.dark}
        >
          <FormattedMessage id="button.downloadCase" />
        </StyledButton>
        <FormModal
          lang={lang}
          open={open}
          handleClose={handleClose}
          type={FORM_TYPES[`USE_CASE_${lang.toUpperCase()}`]}
          values={{ name: translatedUseCase }}
          useCase={clientCase}
        />
      </StyledGrid>
    </Grid>
  );
};
export default KeypointsBlocks;
